<script>
import SidebarLink from '@wielink-application/shared/vue/layouts/partials/sidebar-link.vue'
export default SidebarLink;
</script>